import {
  Outlet,
  createRootRouteWithContext,
  Link,
} from "@tanstack/react-router";
import { QueryClient } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import { CustomRequestDialog } from "@/components/layouts/CustomRequestDialog";
import { HeadContent } from "@tanstack/react-router";
import { Home } from "lucide-react";
import { ChefHat } from "@/components/svg/ChefHat";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: () => (
    <>
      <HeadContent />
      <div className="min-h-screen bg-background font-outfit w-full">
        <Outlet />
        {/* <TanStackRouterDevtools /> */}
        <Toaster position="top-right" className="py-6" />
        <CustomRequestDialog />
      </div>
    </>
  ),
  notFoundComponent: () => (
    <div className="min-h-screen flex items-center justify-center bg-salmon font-sans">
      <div className="text-center space-y-6 p-8 max-w-md">
        <ChefHat className="mx-auto text-primary w-24 h-24" />
        <h1 className="text-4xl font-bold text-foreground font-sans">
          404 - Page Non Trouvée
        </h1>
        <p className="text-xl text-foreground/80">
          Oups ! Il semble que nous ayons égaré cette recette. Retournons en
          cuisine.
        </p>
        <div className="w-1/2 h-1 bg-primary mx-auto rounded-full" />
        <Link
          to="/"
          className="inline-flex items-center px-6 py-3 text-lg font-medium text-primary-foreground bg-primary rounded-full hover:bg-primary/90 transition-colors duration-300"
        >
          <Home className="mr-2 h-5 w-5" />
          Retour à l&apos;Accueil
        </Link>
      </div>
    </div>
  ),
});
